import script from "./InstallBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstallBanner.vue?vue&type=script&lang=ts&setup=true"

import "./InstallBanner.vue?vue&type=style&index=0&id=61934592&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61934592"]])

export default __exports__